export default "__VITE_ASSET__BRH4PnxF__"